module.exports = __webpack_public_path__ + "static/media/back8.d050b54c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backs/back8.jpg
// module id = 1197
// module chunks = 0